module.exports = __webpack_public_path__ + "static/img/bg.3e249adf.jpg";